/*! License details at fancyapps.com/license */
var t = function t() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return Math.max(Math.min(n, a), t);
};
export { t as clamp };